module.exports = __webpack_public_path__ + "media/american-robin-2.44aefbec.mp3";